import axiosInstance from "./axios.service"

// producto al que pertenece un grupo raíz (Cartelería / Turnos)
export type ItemRankingGroupTag = 'SIGNAGE' | 'TURNS'
export const ITEM_RANKING_GROUP_TAGS: ItemRankingGroupTag[] = ['SIGNAGE', 'TURNS']

export interface ItemRankingGroup {
  _id?: string
  name: string
  parent?: string
  sortIndex?: number
  tags?: ItemRankingGroupTag[]
}

// cambios parciales de un grupo para arraySave (solo los campos enviados se actualizan)
export interface ItemRankingGroupIndex {
  _id: string
  sortIndex?: number
  tags?: ItemRankingGroupTag[]
}

export default { query, queryNoPaginate, save, arraySave, remove }

async function query(filter: any): Promise<ItemRankingGroup[]> {
  const params = { _select: '*', ...filter }
  const result = await axiosInstance.get('/api/itemRankingGroup', { params })
  return result.data
}

async function queryNoPaginate(filter: any): Promise<ItemRankingGroup[]> {
  const params = { _select: '*', ...filter, _paginate: false }
  const result = await axiosInstance.get('/api/itemRankingGroup', { params })
  return result.data
}

async function save(data: ItemRankingGroup): Promise<ItemRankingGroup> {
  const result = await axiosInstance.post('/api/itemRankingGroup', data)
  return result.data
}

async function arraySave(data: ItemRankingGroupIndex[]): Promise<ItemRankingGroup[]> {
  const result = await axiosInstance.post('/api/itemRankingGroup', data)
  return result.data
}

async function remove(_id: string): Promise<ItemRankingGroup> {
  if (!_id || _id.trim() === '') throw new Error('No se puede borrar sin id')
  const result = await axiosInstance.put('/api/itemRankingGroup', { _id })
  return result.data
}
